module.exports = __webpack_public_path__ + "img/Blue-R-3@2x.443fd6cb.png";